import React from 'react';

import type { BoardRecoveryState } from './boardDeficit';

import styles from './BoardMissingNotice.module.scss';

export const BOARD_MISSING_TITLE = 'Board not received';
export const BOARD_MISSING_DETAIL = 'Reconnect to load the cards';
export const BOARD_RECONNECTING_DETAIL = 'Reconnecting…';
export const BOARD_UNAVAILABLE_DETAIL = 'Check Hand History for the cards';
export const BOARD_RECONNECT_LABEL = 'Reconnect';

/** Class for a board slot whose dealt card is missing (see boardDeficit). */
export const missingSlotClassName = styles.missingSlot;

const DETAIL: Record<Exclude<BoardRecoveryState, 'none'>, string> = {
  missing: BOARD_MISSING_DETAIL,
  reconnecting: BOARD_RECONNECTING_DETAIL,
  unavailable: BOARD_UNAVAILABLE_DETAIL
};

/**
 * EN-11031: shown beneath the board when a dealt street is missing from client
 * state (see boardDeficit), so the player is told the board is absent instead
 * of being left to act on a felt that looks like no card came.
 */
const BoardMissingNotice = ({
  state,
  onReconnect
}: {
  state: Exclude<BoardRecoveryState, 'none'>;
  onReconnect: () => void;
}) => (
  <div className={styles.anchor} role='status' aria-live='polite'>
    <div className={styles.pill}>
      <div className={styles.copy}>
        <span className={styles.title}>{BOARD_MISSING_TITLE}</span>
        <span className={styles.detail}>{DETAIL[state]}</span>
      </div>
      {state === 'missing' && (
        <button type='button' className={styles.reconnect} onClick={onReconnect}>
          {BOARD_RECONNECT_LABEL}
        </button>
      )}
    </div>
  </div>
);

export default BoardMissingNotice;
